import React, { Component } from 'react';
import classnames from 'classnames';
import moment from 'moment';

class CommunityUserLinkedinDataView extends Component {

    createExperienceHtml(user) {
        let experienceContent = this.createExperienceContent(user);
        if (!user.linkedinInfo || Object.keys(user.linkedinInfo).length === 0) {
            return <div />;
        }

        return <div className="experience-content">
            {experienceContent.positions && this.createPositions(experienceContent.positions)}
            {experienceContent.educations && this.createEducations(experienceContent.educations)}
        </div>;
    }

    createDetailItem(title, icon, text) {
        let iconToDisplay = 'icon icon-' + icon + ' detail-icon';
        return <div className="detail-item-container color-1-border padding-top-small">
            <span className="make-relative">
                <i className={iconToDisplay} />
            </span>
            <span className="experience-title padding-left-small">{title}</span>
            <div className="padding-left-small">{text}</div>
        </div>;
    }


    createExperienceContent(user) {
        let experienceContent = {}, month;
        let positions = user.linkedinInfo && user.linkedinInfo.positions && user.linkedinInfo.positions || {};
        let newPositions;
        if (positions._total > 0 && positions.values) {
            newPositions = positions.values.map(function(position) {
                let newPosition = {};
                newPosition.title = position.title;
                newPosition.summary = position.summary;
                newPosition.companyName = position.company && position.company.name;
                if (position.startDate) {
                    newPosition.startDate = '';
                    month = position.startDate && position.startDate.month;
                    if (month) {
                        newPosition.startDate = moment().month(position.startDate.month).format('MMMM') + ' ';
                    }
                    newPosition.startDate += position.startDate.year;
                }
                if (position.isCurrent) {
                    newPosition.endDate = 'present';
                } else {
                    newPosition.endDate = '';
                    month = position.endDate && position.endDate.month;
                    if (month) {
                        newPosition.endDate = moment().month(position.endDate.month).format('MMMM') + ' ';
                    }
                    newPosition.endDate += position.endDate.year;
                }
                return newPosition;
            });
        }
        experienceContent.positions = newPositions;
        let educations = user.linkedinInfo && user.linkedinInfo.educations || {};
        let newEducations;
        if (educations._total > 0 && educations.values) {
            newEducations = educations.values.map(function(education) {
                let newEducation = {};
                newEducation.schoolName = education.schoolName;
                newEducation.degree = education.degree;
                newEducation.degree += education.fieldOfStudy ? `,  ${education.fieldOfStudy}` : '';
                if (education.startDate) {
                    newEducation.startDate = '';
                    month = education.startDate && education.startDate.month;
                    if (month) {
                        newEducation.startDate = moment().month(education.startDate.month).format('MMMM') + ' ';
                    }
                    newEducation.startDate += education.startDate.year;
                }
                newEducation.endDate = '';
                month = education.endDate && education.endDate.month;
                if (month) {
                    newEducation.endDate = moment().month(education.endDate.month).format('MMMM') + ' ';
                }
                newEducation.endDate += education.endDate && education.endDate.year;
                newEducation.activities = education.activities;
                newEducation.notes = education.notes;
                return newEducation;
            });
        }
        experienceContent.educations = newEducations;
        return experienceContent;
    }

    createPositions(positions) {
        if (!positions) {
            return <div />;
        }
        let positionsArr = positions.map((position, index) => this.getPosition(position, index));
        return this.createDetailItem('Experience', 'company', positionsArr);
    }

    getPosition(position, index) {
        let likePre = classnames({
            'hide': !position.summary
        });
        return <div key={index} className="margin-bottom-medium linkedin-data-item">
            <strong>{position.title}</strong><br/>
            <strong>{position.companyName}</strong>

            <div>{position.startDate} - {position.endDate}</div>
            <div className={likePre}>{position.summary}</div>
        </div>;
    }

    createEducations(educations) {
        if (!educations) {
            return <div />;
        }
        let educationsArr = educations.map((education, index) => this.getEducation(education, index));
        return this.createDetailItem('Education', 'education', educationsArr);
    }

    getEducation(education, index) {
        return <div key={index} className="margin-bottom-medium linkedin-data-item">
            <div><strong>{education.schoolName}</strong></div>
            <div><strong>{education.degree}</strong></div>
            <div>{education.startDate} - {education.endDate}</div>
            <div>{education.activities}</div>
            <div>{education.notes}</div>
        </div>;
    }

    render() {
        let { user } = this.props;
        return <div className="community-user-linkedin-data-wraaper">
            {this.createExperienceHtml(user)}
        </div>;
    }
}

export default CommunityUserLinkedinDataView;


